import { Directive, Input, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { LayoutService } from '@common/services/layout.service';

@Directive({
  selector: '[observe]'
})
export class ObserveDirective implements OnDestroy {

  private observers: { disconnect: () => void }[] = [];

  @Input()
  public set observe(types: 'content' | 'size' | ('content' | 'size')[]) {

    if (typeof types == 'string') types = [types];

    this.observers.forEach(o => o.disconnect());
    this.observers = [];

    if (types) {
      types.distinct().forEach(type => {
        switch (type) {
          case 'content': {

            let o = new MutationObserver(() => this.layout.change.emit({ type: 'content', scope: this.ref.nativeElement }));
            o.observe(this.ref.nativeElement, { subtree: true, characterData: true });
            this.observers.push(o);
            break;
          }

          case 'size': {

            let o = new ResizeObserver(() => this.layout.resize.emit({ type: 'content', scope: this.ref.nativeElement, width: this.ref.nativeElement.clientWidth, height: this.ref.nativeElement.clientHeight }));
            o.observe(this.ref.nativeElement);
            this.observers.push(o);
            break;
          }
        }
      });
    }
  }

  constructor(private ref: ElementRef, private layout: LayoutService) {
  }

  ngOnDestroy() {
    this.observers.forEach(o => o.disconnect());
  }
}
